import { NgModule } from '@angular/core';

import { MainHomeComponent } from './home/home.component';
import { MainComponent } from './main.component';
import { SharedModule } from '../shared/_service/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { ProfiloComponent } from './_utente/profilo/profilo.component';
import { FooterComponent } from './footer/footer.component';
import { AuthGuard } from '../auth/_guard/auth.guard';
import { CarrelloComponent } from './_utente/carrello/carrello.component';
import { OrdersComponent } from './_utente/orders/orders.component';
import { CategoryComponent } from './_utente/category/category.component';
import { DetailComponent } from './_utente/detail/detail.component';
import { TrackingComponent } from './_utente/tracking/tracking.component';
import { RisultatiRicercaComponent } from './_utente/risultati-ricerca/risultati-ricerca.component';
import { ConfigurazioneClienteComponent } from './_cms/configurazione-cliente/configurazione-cliente.component';
import { NuovoUtenteComponent } from './_cms/nuovo-utente/nuovo-utente.component';
import { OrdiniCmsComponent } from './_cms/ordini-cms/ordini-cms.component';
import { ConfigurazioneUtentiComponent } from './_cms/configurazione-utenti/configurazione-utenti.component';
import { ShopByCodeComponent } from './_utente/carrello/shop-by-code/shop-by-code.component';
import { ImportExcelComponent } from './_utente/carrello/import-excel/import-excel.component';
import { TranslateModule } from '@ngx-translate/core';
import { SeriesComponent } from './_utente/series/series.component';
import { ConfigurazioneColoriComponent } from './_cms/configurazione-colori/configurazione-colori.component';
import { AccessoriComponent } from './_utente/accessori/accessori.component';
import { DetailAccessoriesComponent } from './_utente/detail-accessories/detail-accessories.component';
import { EditContainerComponent } from './container/edit-container/edit-container.component';
import { HandleContainersComponent } from './container/handle-containers/handle-containers.component';
import { NewContainerComponent } from './container/new-container/new-container.component';
import { ContainerCanvasComponent } from './container/edit-container/container-canvas/container-canvas.component';
import { ContainerLayoutPdfComponent } from './container/edit-container/container-layout-pdf/container-layout-pdf.component';
import { TranscodificaComponent } from './_cms/transcodifica/transcodifica.component';
import { ConfigurazioneLimiteScontiComponent } from './_cms/configurazione-limite-sconti/configurazione-limite-sconti.component';
import { OrdiniAgentiComponent } from './_cms/ordini-agenti/ordini-agenti.component';
import { TabellaConfigurazioneProdottoContainerComponent } from './_cms/tabella-configurazione-prodotto-container/tabella-configurazione-prodotto-container.component';
import { ControlloErroriVisibilitaProdottiComponent } from './_cms/controllo-errori-visibilita-prodotti/controllo-errori-visibilita-prodotti.component';
import { ConfigurazioneCompanyComponent } from './_cms/configurazione-company/configurazione-company.component';
import { SoloUsaDirective } from '../shared/_directive/solo-usa.directive';
import { SoloItaDirective } from '../shared/_directive/solo-ita.directive';

const routes: Routes = [
	{
		path: '',
		component: MainComponent,
		canActivate: [AuthGuard],
		children: [
			{ path: '', component: MainHomeComponent },

			// Parte utente
			{ path: 'profile', component: ProfiloComponent },
			{ path: 'cart', component: CarrelloComponent },
			{ path: 'category', component: CategoryComponent },
			{ path: 'category/:codiceCommerciale', component: DetailComponent },
			{ path: 'series', component: SeriesComponent },
			{ path: 'series/:codiceCommerciale', component: DetailComponent },
			{ path: 'orders', component: OrdersComponent },
			{ path: 'tracking', component: TrackingComponent },
			{ path: 'search', component: RisultatiRicercaComponent },
			{ path: 'accessori', component: AccessoriComponent },
			{ path: 'accessori/:codiceCommerciale', component: DetailAccessoriesComponent },
			{ path: 'containers', component: HandleContainersComponent },
			{ path: 'edit-container/:id', component: EditContainerComponent },
			{ path: 'new-container', component: NewContainerComponent },

			// Parte CMS
			{ path: 'configurazione-cliente', component: ConfigurazioneClienteComponent },
			{ path: 'configurazione-colori', component: ConfigurazioneColoriComponent },
			{ path: 'configurazione-utente', component: ConfigurazioneUtentiComponent },
			{ path: 'configurazione-limite-sconti', component: ConfigurazioneLimiteScontiComponent },
			{ path: 'configurazione-utente/:id', component: NuovoUtenteComponent },
			{ path: 'ordini-cms', component: OrdiniCmsComponent },
			{ path: 'containers', component: HandleContainersComponent },
			{ path: 'edit-container/:id', component: EditContainerComponent },
			{ path: 'new-container', component: NewContainerComponent },
			{ path: 'transcodifica', component: TranscodificaComponent },
			{ path: 'ordini-agente', component: OrdiniAgentiComponent },
			{ path: 'configurazione-containerizzatore', component: TabellaConfigurazioneProdottoContainerComponent },
			{ path: 'controllo-errori-visibilita-prodotti', component: ControlloErroriVisibilitaProdottiComponent },
			{ path: 'configurazione-company', component: ConfigurazioneCompanyComponent },
		],
	},
];

@NgModule({
	declarations: [
		MainComponent,
		MainHomeComponent,
		HeaderComponent,
		ProfiloComponent,
		FooterComponent,
		CarrelloComponent,
		OrdersComponent,
		CategoryComponent,
		DetailComponent,
		TrackingComponent,
		RisultatiRicercaComponent,
		ConfigurazioneClienteComponent,
		NuovoUtenteComponent,
		OrdiniCmsComponent,
		ConfigurazioneUtentiComponent,
		ShopByCodeComponent,
		ImportExcelComponent,
		SeriesComponent,
		ConfigurazioneColoriComponent,
		AccessoriComponent,
		DetailAccessoriesComponent,
		NewContainerComponent,
		HandleContainersComponent,
		EditContainerComponent,
		ContainerCanvasComponent,
		ContainerLayoutPdfComponent,
		TranscodificaComponent,
		ConfigurazioneLimiteScontiComponent,
		OrdiniAgentiComponent,
		TabellaConfigurazioneProdottoContainerComponent,
		ControlloErroriVisibilitaProdottiComponent,
		ConfigurazioneCompanyComponent,
		SoloUsaDirective,
		SoloItaDirective,
	],
	imports: [SharedModule, TranslateModule.forChild(), RouterModule.forChild(routes)],
	exports: [],
	providers: [],
})
export class MainModule {}
